import React from "react";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
  SummaryGrid,
  SummaryItem,
  SummaryLabel,
  SummaryValue,
} from "./MonthlyReport.styles";
import { Receipt } from "@mui/icons-material";
import { formatNumber, isPositiveAmount } from "./MonthlyReport.utils";

const MonthlyReportSummary = ({ summary }) => {
  if (!summary) return null;

  return (
    <GridItem xs={12} padding="0 0 15px 0">
      <DataCard>
        <DataCardHeader>
          <Receipt color="primary" />
          <DataCardTitle>General Summary</DataCardTitle>
        </DataCardHeader>
        <SummaryGrid spacing={1}>
          <GridItem xs={12} sm={6} md={3}>
            <SummaryItem>
              <SummaryLabel>Amount</SummaryLabel>
              <SummaryValue>${formatNumber(summary.total_transaction_amount)}</SummaryValue>
            </SummaryItem>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <SummaryItem>
              <SummaryLabel>Transactions</SummaryLabel>
              <SummaryValue>{summary.total_transaction_count || 0}</SummaryValue>
            </SummaryItem>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <SummaryItem>
              <SummaryLabel>Net Residual</SummaryLabel>
              <SummaryValue positive={isPositiveAmount(summary.total_fees)}>
                ${formatNumber(summary.total_fees)}
              </SummaryValue>
            </SummaryItem>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <SummaryItem>
              <SummaryLabel>Terminals</SummaryLabel>
              <SummaryValue>{summary.terminal_count || 0}</SummaryValue>
            </SummaryItem>
          </GridItem>
          <GridItem xs={12} sm={6} md={3}>
            <SummaryItem>
              <SummaryLabel>Merchants</SummaryLabel>
              <SummaryValue>{summary.merchant_count || 0}</SummaryValue>
            </SummaryItem>
          </GridItem>
        </SummaryGrid>
      </DataCard>
    </GridItem>
  );
};

export default MonthlyReportSummary;

